import { addMethod, Schema, ValidationError } from 'yup';

export function initializeYup() {
  addMethod(Schema, 'safeValidateSync', function (data, options) {
    try {
      const value = this.validateSync(data, options);
      return { success: true, data: value };
    } catch (error) {
      let enhancedError;

      if (error instanceof ValidationError) {
        enhancedError = {
          success: false,
          error: {
            message: error.message,
            path: error.path,
            errors: error.errors,
            inputContext: data
          }
        };
      } else {
        enhancedError = {
          success: false,
          error: {
            message: 'An unexpected error occurred during validation.',
            originalError:
              error instanceof Error ? error.message : String(error),
            stack: error instanceof Error ? error.stack : undefined,
            inputContext: data
          }
        };
      }

      console.error('Validation Error: ' + enhancedError.error.message, {
        message: enhancedError.error.message,
        path: error instanceof ValidationError ? error.path : undefined,
        errors: error instanceof ValidationError ? error.errors : undefined,
        stack: error instanceof Error ? error.stack : undefined,
        inputContext: data
      });

      return enhancedError;
    }
  });
}
